import React from "react";

const AboutBanner = () => {
  return (
    <div className="">
      <div className="about-banner">
        <div className="about-banner-content">
          <h1>
            INTERNATIONAL CERTIFICATION <br /> WITH  CONFIDENCE.
          </h1>
          <h6>Helping businesses achieve global standards with confidence</h6>
          <p>
            Our mission is to simplify ISO certification, providing businesses
            with expert guidance, efficient <br /> processes, and lasting
            compliance to meet global standards.
          </p>
          <button className="about-banner-btn">Get Started</button>
        </div>
      </div>

      <div className="trusted-globally-banner">
        <div className="trusted-globally-banner-content">
          <div className="">
            <h1 className="trusted-globally-banner-content-heading">
              Trusted Globally, <br />
              Proven Expertise
            </h1>
          </div>
          <div className="d-flex align-items-center gap-1 trusted-globally-banner-right">
            <div className=" ">
               <div className="trusted-globally-banner-right-content">
                <h2>12+</h2>
               </div>
              <span className="trusted-globally-banner-right-content-span">Countries</span>
            </div>
            <div  >
               <div className="trusted-globally-banner-right-content">
                <h2>150</h2>
               </div>
              <span className="trusted-globally-banner-right-content-span">Technical Experts</span>
            </div>
            <div
              
            >
               <div className="trusted-globally-banner-right-content"  style={{ border: "none" }}>
                <h2>12+</h2>
               </div>
              <span className="trusted-globally-banner-right-content-span">Happy Customers</span>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default AboutBanner;
